export default "__VITE_ASSET__fc4c68e0__"